import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import TextField from '../../TextField';
import NewSearchCities from '../../../NewSearch/NewSearchCities';
import NewSearchLocations from '../../../NewSearch/NewSearchLocations';
import SelectVillage from '../../SelectVillage';
import SelectLocationMapComponent from '../../SelectLocationMapComponent';
import ErrorField from '../components/ErrorField';
import { FORM_VALUES } from '../../../../utils/helpers/constants';

const ADDRESS_CHAR_LIMIT = '3000';

const EstateLocation = ({ citiesLoading, setCitiesIsLoading }) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const locationId = values[FORM_VALUES.locationId];
  const cityHasLocations = useSelector(
    state => state.addNewItemModal.cityHasLocations
  );
  const [initCoordinates, setInitCoordinates] = useState();
  const [citiesPopupIsOpen, setCitiesPopupIsOpen] = useState(false);
  const [locationsIsLoading, setLocationsIsLoading] = useState(false);
  const [villagePopupIsOpen, setVillagePopupIsOpen] = useState(false);
  const [locationsPopupIsOpen, setLocationsPopupIsOpen] = useState(false);

  const toggleHandlerCities = () => setCitiesPopupIsOpen(!citiesPopupIsOpen);
  const toggleHandlerVillage = () => setVillagePopupIsOpen(!villagePopupIsOpen);
  const toggleHandlerLocations = () =>
    setLocationsPopupIsOpen(!locationsPopupIsOpen);

  return (
    <div className="filters__section filters--no-border-top">
      <div className="item-modal__block-header">
        {t('search.locations_search.title')}
      </div>
      <NewSearchCities
        listType="create"
        citiesPopupIsOpen={citiesPopupIsOpen}
        setCitiesLoading={setCitiesIsLoading}
        toggleHandlerCities={toggleHandlerCities}
      />
      <NewSearchLocations
        listType="create"
        formValues={values}
        setInitCoordinates={setInitCoordinates}
        locationsPopupIsOpen={locationsPopupIsOpen}
        setLocationsIsLoading={setLocationsIsLoading}
        toggleHandlerLocations={toggleHandlerLocations}
      />
      {locationId && (
        <>
          <SelectVillage
            setInitCoordinates={setInitCoordinates}
            villagePopupIsOpen={villagePopupIsOpen}
            toggleHandlerVillage={toggleHandlerVillage}
          />
          <div className="divider" />
        </>
      )}
      {!citiesLoading &&
        !locationsIsLoading &&
        (!cityHasLocations || locationId) && (
          <>
            <TextField
              name={FORM_VALUES.address}
              maxLength={ADDRESS_CHAR_LIMIT}
              placeholder={t('new_ad.address')}
              value={values[FORM_VALUES.address]}
            />
            <ErrorField
              field={FORM_VALUES.address}
              cypress="address-field-error"
            />
            <SelectLocationMapComponent initialLocation={initCoordinates} />
          </>
        )}
    </div>
  );
};

EstateLocation.propTypes = {
  citiesLoading: PropTypes.bool.isRequired,
  setCitiesIsLoading: PropTypes.func.isRequired
};

export default EstateLocation;
